import {Box, Modal, Text, Title} from '@mantine/core';
import {useRouter} from 'next/router';
import {type FC, useEffect, useRef, useState} from 'react';
import {MdCheckCircle} from 'react-icons/md';
import {AC_VERIFIED_QUERY_PARAM} from '../../../core/entities/register/constants';
import {modalConfig} from '../../../shared/components/modalConfig';
import {useIsAppWebView} from '../../../shared/hooks/useIsAppWebView';

export const AcVerifyCompletedModal: FC = () => {
  const router = useRouter();
  const isWebView = useIsAppWebView();
  const [opened, setOpened] = useState(false);
  const closedRef = useRef(false);

  // クライアント遷移では初回レンダリング時にqueryが空。
  useEffect(() => {
    if (
      !closedRef.current &&
      router.isReady &&
      router.query[AC_VERIFIED_QUERY_PARAM] === '1'
    ) {
      setOpened(true);
    }
  }, [router.isReady, router.query]);

  const onClose = () => {
    closedRef.current = true;
    setOpened(false);

    // webviewではnext/routerがエラーになるため何もしない
    if (isWebView) {
      return;
    }

    // リロードや共有で復活させない。
    // router.queryにはハッシュが含まれないため、実URLから組み立てて保持する。
    const url = new URL(window.location.href);
    url.searchParams.delete(AC_VERIFIED_QUERY_PARAM);
    void router.replace(`${url.pathname}${url.search}${url.hash}`, undefined, {
      shallow: true,
    });
  };

  return (
    <Modal
      className="w-[343px] pc:w-[560px]"
      radius={16}
      opened={opened}
      onClose={onClose}
      {...modalConfig}
      withCloseButton
      closeButtonProps={{'aria-label': '閉じる'}}
      styles={{
        // タイトルを置かないため、既定の space-between だとバツが左に寄る
        header: {padding: 12, paddingBottom: 0, justifyContent: 'flex-end'},
      }}
    >
      <div
        className="flex flex-col gap-y-12 rounded-16 bg-white p-20 pc:gap-y-16 pc:p-24"
        data-gtm-imp="ac-verify-completed-modal"
      >
        <div className="flex flex-col items-center text-center">
          <Box className="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-background-3">
            <MdCheckCircle size={28} className="text-primary-1" />
          </Box>
          <Title
            order={2}
            className="mt-16 text-lg font-bold leading text-black-1"
          >
            大学メールアドレス認証完了
          </Title>
          <Text className="mt-8 text-sm leading text-black-2">
            大学メールアドレスの認証が完了しました。本登録が完了し、すべての機能がご利用いただけます。
          </Text>
        </div>

        <button
          type="button"
          onClick={onClose}
          className="text-base text-black-3 font-bold mx-auto hover:opacity-70"
        >
          閉じる
        </button>
      </div>
    </Modal>
  );
};
